import React, { useContext } from "react";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../../app/stores/rootStore";
import { Accordion, Icon, Segment } from "semantic-ui-react";
import BreadcrumbContainer from "../../../app/common/breadcrumb/BreadcrumbContainer";
import { sectionReport } from "../../../app/util/breadcrumbOptions";
import TenantFilter from "./TenantFilter";
import TenantFilterInfo from "./TenantFilterInfo";
import ListTenantReport from "./ListTenantReport";

const DashboardTenantReport: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const {
    acordionBrokerFilter,
    changeStateAcordionBroker,
  } = rootStore.reportStore;

  document.title = "Consumo mensual por cliente";
  return (
    <div className="configurationContent">
      <BreadcrumbContainer
        title="Consumo mensual por cliente"
        sections={sectionReport}
      />
      <Segment className="accordionSegment">
        <Accordion>
          <Accordion.Title
            active={acordionBrokerFilter}
            onClick={() => changeStateAcordionBroker()}
          >
            <Icon name="dropdown" />
            {acordionBrokerFilter ? "Ocultar filtros" : "Ver filtros"}
          </Accordion.Title>
          <Accordion.Content active={acordionBrokerFilter}>
            <TenantFilter />
          </Accordion.Content>
          <Accordion.Content active={!acordionBrokerFilter}>
            <TenantFilterInfo />
          </Accordion.Content>
        </Accordion>

        <ListTenantReport />
        <br />
      </Segment>
    </div>
  );
};

export default observer(DashboardTenantReport);
